import React from "react";
import {useSelector} from "react-redux";

import Box from "../../Interface/Box";
import Separator from "../../Interface/Separator/Separator";
import BalanceRow from "../../Interface/BalanceRow";
import {convertBalance, prettifyNumber} from "../../../utils";

function Holdings() {
    const roobeeBalance = useSelector(store => store.staking.roobeeBalance);
    const xRoobeeBalance = useSelector(store => store.govToken.userBalance);

    return (
        <Box direction="column" align="flex-start">
            Wallet Holdings
            <Separator />
            <BalanceRow name="ROOBEE" value={convertBalance(roobeeBalance)} />
            <BalanceRow name="xROOBEE" value={convertBalance(xRoobeeBalance)} />
        </Box>
    );
}

export default Holdings;
